export default "__VITE_ASSET__Bvq$aWT$__"